<div class="deal-type-header">
  <span class="deal-type-header__title">Create New Deal</span>
  <span class="deal-type-header__subtitle">Select deal status</span>
  <button mat-icon-button mat-dialog-close class="deal-type-header__close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="deal-type-cards">
    <button
      class="deal-type-card"
      [class.deal-type-card--selected]="selected() === 'current'"
      (click)="selectCurrentDeal()">
      <mat-icon class="deal-type-card__icon">bar_chart</mat-icon>
      <span class="deal-type-card__title">Current Deal</span>
      <span class="deal-type-card__description">
        Deal in progress - upload term sheet or enter manually
      </span>
    </button>

    <button
      class="deal-type-card"
      [class.deal-type-card--selected]="selected() === 'closed'"
      (click)="selectClosedDeal()">
      <mat-icon class="deal-type-card__icon">check</mat-icon>
      <span class="deal-type-card__title">Closed Deal</span>
      <span class="deal-type-card__description">
        Completed transaction - enter manually
      </span>
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
